import { ManagePages } from "../types"

const rolePaths = {
  [ManagePages.DistrictAdmins]: "district-admins",
  [ManagePages.SchoolAdmins]: "school-admins",
  [ManagePages.Teachers]: "teachers",
  [ManagePages.Students]: "students"
}

export const getRestorePath = (managePage: ManagePages, searchParams: string) =>
  // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
  `/manage/organization/${rolePaths[managePage]}/restore${searchParams}`
